module.exports = __webpack_public_path__ + "static/media/youtube.e66424d0.png";